<template>
  <div class="elichain-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-content" >
            <div class="header-wrapper">
              <div class="header">
                <div class="logo"><img src="@/assets/login/logo.png"></div>
                <div class="remark">
                  <div class="title">慕鹿 Elichian</div>
                  <div class="desc">科技改变未来   只因我们都在</div>
                </div>
              </div>
              <img src="@/assets/HedaerWave.png" class="wave_bg">
            </div>
            <div class="info">
              <div class="title">
                <div class="tit">慕鹿是什么</div>
                <div class="txt">What Is This</div>
              </div>
              <div class="desc">
                慕鹿平台，是杭州乔金斯科技集团有限公司软件技术研发中心团队为乔金斯打造的互联网生态平台，以多维度管理及服务一体化平台、整合大系统建立乔金斯生态链的大数据，通过大数据来提升乔金斯的服务、品质、设计，增强乔金斯的品牌效应。<br>
                慕鹿整合了乔金斯所有平台及系统，建立庞大的生态数据池，根据不同需求，提供不同的数据库及运营工具，通过平台对门店及内部的服务管控，增强学习培训，提高乔金斯服务质量，通过对售后数据的积累，更快的能分析出品质问题出在哪，也能更好的做出预估，平台处理业务过程中，将自动沉淀用户及设计数据，以及提供外部数据分享， 建立市场资源库，可更好的分析出设计方面的市场走向。
                项目以多维度管理及服务一体化平台、整合大系统建立乔金斯生态链的大数据，通过大数据来提升乔金斯的服务、品质、设计，增强乔金斯的品牌效应，为大家居、 大健康、大教育方向埋下重要的伏笔。
              </div>
              <div class="title">
                <div class="tit">慕鹿名字由来</div>
                <div class="txt">The Origin Of The Name</div>
              </div>
              <div class="desc">
                “慕”为思念、思想的意思， “鹿”象征着健康、幸福、吉祥，是美好生活的体现，代表着我们想要实现美好生活的憧憬。“慕鹿” 音译“目录”，指的是书籍的第一页，是揭示和报道图书的工具，也是记录图书的书名、著者、出版与收藏等情况。形容着美好生活这本书的目录，更形容着乔金斯里每一个人都是这本书的撰写者，而客户就是通过慕鹿来阅读美好生活这本书的目录。
              </div>
              <div class="title">
                <div class="tit">Elichain是什么</div>
                <div class="txt">What Is Elichain</div>
              </div>
              <div class="desc">
                Elichain是慕鹿生态平台的英文标识，“elichain”所属南非科萨语，词意为“链”，“e”是互联网的代表，“lic”是许可证执照的意思，“chain”指的是生态链，“elichain”代表着乔金斯互联网生态链的一种标志。
              </div>
              <div class="title">
                <div class="tit">TCF 团队介绍</div>
                <div class="txt">Team Introduction</div>
              </div>
              <div class="team-info">
                <el-row>
                  <el-col :span="6">
                    <div class="user-info">
                      <div class="name">
                        <div class="photo">
                          <el-avatar :size="50" shape="square" :src="yangming"></el-avatar>
                        </div>
                        <span>杨名</span>
                        <div class="txt">技术总监/全栈开发</div>
                      </div>
<!--                      <div class="desc">-->
<!--                         负责慕鹿平台架构设计及搭建-->
<!--                      </div>-->
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="user-info">
                      <div class="name">
                        <div class="photo">
                          <el-avatar :size="50" shape="square" :src="wangyuxin"></el-avatar>
                        </div>
                        <span>王玉鑫</span>
                        <div class="txt">项目经理/全栈开发</div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="user-info">
                      <div class="name">
                        <div class="photo">
                          <el-avatar :size="50" shape="square" :src="liuzhigao"></el-avatar>
                        </div>
                        <span>刘志高</span>
                        <div class="txt">APP全栈开发</div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="user-info">
                      <div class="name">
                        <div class="photo">
                          <el-avatar :size="50" shape="square" :src="yinxiangwen"></el-avatar>
                        </div>
                        <span>殷想文</span>
                        <div class="txt">Android/全栈开发</div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <el-row style="margin-top: 20px">
                  <el-col :span="6">
                    <div class="user-info">
                      <div class="name">
                        <div class="photo">
                          <el-avatar :size="50" shape="square" :src="gaoxiaojin"></el-avatar>
                        </div>
                        <span>高小金</span>
                        <div class="txt">全栈开发</div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="user-info">
                      <div class="name">
                        <div class="photo">
                          <el-avatar :size="50" shape="square" :src="zhangjinyang"></el-avatar>
                        </div>
                        <span>张金阳</span>
                        <div class="txt">全栈开发</div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="user-info">
                      <div class="name">
                        <div class="photo">
                          <el-avatar :size="50" shape="square" :src="yangtongtong"></el-avatar>
                        </div>
                        <span>杨童童</span>
                        <div class="txt">UI/前端开发</div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div class="desc">
                一直以来，我们秉承用科技改变未来的初心，虔诚致力于服务乔金斯各事业部门以及经销商，在互联网科技横飞的当今时代，这一信念从未动摇。即便身单力薄，仍然重拾决心，埋头造轮，以尽可能地填补平台与服务本身的缺口。
                <span style="float: right;">TCF Technology(Team) Changes Future</span>
              </div>
              <div class="title">
                <div class="tit">联系我们</div>
                <div class="txt">Contact Us</div>
              </div>
              <div class="desc" style="padding-left: 120px;position: relative;padding-top:5px">
                <img src="@/assets/qrcode_mulu.jpg" style="height: 110px;position: absolute;left:0;top:0;">
                <i class="el-icon-phone-outline"></i> 联系电话：18658755873<br>
                <i class="el-icon-message"></i> 电子邮箱：jokinsmulu@163.com<br>
                <i class="el-icon-link"></i> 慕鹿官网：www.mulu.life<br>
                <i class="el-icon-map-location"></i> 所在地址：杭州市滨江区阿里中心3号楼705室
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import liuzhigao from '@/assets/liuzhigao.jpg'
import wangyuxin from '@/assets/wangyuxin.jpg'
import yangming from '@/assets/yangming.jpg'
import yinxiangwen from '@/assets/yinxiangwen.jpg'
import gaoxiaojin from '@/assets/gaoxiaojin.jpg'
import zhangjinyang from '@/assets/zhangjinyang.jpg'
import yangtongtong from '@/assets/yangtongtong.png'
export default {
  name: 'elichain',
  computed: {
    user: getUser
  },
  data() {
    return {
      liuzhigao: liuzhigao,
      wangyuxin: wangyuxin,
      yangming: yangming,
      yinxiangwen: yinxiangwen,
      gaoxiaojin: gaoxiaojin,
      zhangjinyang: zhangjinyang,
      yangtongtong: yangtongtong
    }
  }
}
</script>

<style lang="scss" scoped>
.elichain-container {
  .card-body{
    overflow: hidden;
  }
  .header-wrapper{
    position: relative;
    height: 330px;
    .header{
      width: 100%;
      padding-left: 60px;
      padding-right: 60px;
      margin: 0 auto;
      text-align: center;
      padding-top: 50px;
      .logo{
        width: 100%;
        position: relative;
        text-align: center;
        img{
          height: 80px;
        }
      }
      .remark{
        width: 100%;
        position: relative;
        text-align: center;
        .title{
          font-size: 22px;
          font-weight: 400;
          color: #000000;
          letter-spacing: 2px;
        }
        .desc{
          font-size: 14px;
          font-weight: 400;
          color: #222222;
          letter-spacing: 10px;
          padding: 10px 0;
        }
      }
    }
    .wave_bg {
      width: 2560px;
      position: absolute;
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      transform: translateX(-50%);
      left: 50%;
      position: absolute;
      bottom: 0;
    }
  }
  .info{
    width: 100%;
    position: relative;
    padding: 0 50px;
    margin-top: 50px;
    .title{
      width: 100%;
      margin-bottom: 20px;
      .tit{
        font-size: 16px;
        font-weight: 500;
        color:#292b2c;
        letter-spacing: 1px;
      }
      .txt{
        font-size: 12px;
        color:#99a9bf;
        font-weight: 400;
        letter-spacing: 1px;
      }
    }
    .desc{
      font-size: 13px;
      line-height: 26px;
      margin-bottom: 50px;
      letter-spacing: 1px;
    }
  }
  .team-info{
    width: 100%;
    position: relative;
    padding-right: 30px;
    margin-top: 20px;
    margin-bottom: 10px;
    .user-info{
      width: 100%;
      position: relative;
      .name{
        width: 100%;
        height: 50px;
        padding-left: 60px;
        font-size: 12px;
        .photo{
          position: absolute;
          top: 0;
          left: 0;
        }
        span{
          font-size: 16px;
          color:#000;
        }
        .txt{
          margin-top: 6px;
          font-size: 12px;
          color:#909399;
        }
      }
      .desc{
        border-top: 1px solid #f5f7fa;
        margin-top: 10px;
        padding-top: 10px;
      }
    }

  }
}
</style>
